<template>
  <div>
    <h2 class="main-title hidden-print">{{ $t('login.title.main') }}</h2>
    <div class="cso-double-login-component">
      <div v-if="sessionLost"
                       xs="12"
                       class="custom-message-wrapper">
        <p>{{ $t('login.sessionLostMessage') }}</p>
      </div>
      <div v-if="accountLogout"
                       xs="12"
                       class="custom-message-wrapper">
        <p class="title-message">{{ $t('login.accountLogoutTitle') }}</p>
        <p>{{ $t('login.accountLogoutMessage') }}</p>
      </div>
      <div v-if="accountDeleted"
                       xs="12"
                       class="custom-message-wrapper">
        <p>{{ $t('login.accountDeletedMessage') }}</p>
      </div>
      <div v-if="serverErrors"
                       xs="12"
                       class="custom-message-wrapper">
        <p>{{ serverErrors }}</p>
      </div>
      <cso-grid-column l="6"
                       m="6"
                       s="12"
                       xs="12"
                       class="grid-column-wrapper">
        <cso-login-with-password :show-register-button="true"
                                @serverError="getServerError"
                                 header="login.title.withPassword" />
      </cso-grid-column>
      <cso-grid-column l="6"
                       m="6"
                       s="12"
                       xs="12"
                       class="grid-column-wrapper">
        <cso-login-with-link
                              :show-register-button="false"
                             @send="onSend"
                             @serverError="getServerError"
                             :is-double-login="true" />
      </cso-grid-column>
    </div>
  </div>
</template>

<script lang="ts">
import StaticUrls from '@/common/StaticUrls'

import CsoLoginWithLink from './CsoLoginWithLink.vue'
import CsoLoginWithPassword from './CsoLoginWithPassword.vue'

export default {
  name: 'CsoLogin',
  components: {
    CsoLoginWithLink,
    CsoLoginWithPassword
  },

  data () {
    return {
      StaticUrls,
      currentLocation: location.href,
      sessionLost: false,
      accountLogout: false,
      accountDeleted: false,
      deepLink: '/vertragskonto',
      serverErrors: ''
    }
  },
  methods: {
    getUrlId () {
      if (this.currentLocation.indexOf('?sessionLost') !== -1) {
        this.sessionLost = true
      } else {
        this.sessionLost = false
      }
      if (this.currentLocation.indexOf('?accountLogout') !== -1) {
        this.accountLogout = true
      } else {
        this.accountLogout = false
      }
      if (this.currentLocation.indexOf('?accountDeleted') !== -1) {
        this.accountDeleted = true
      } else {
        this.accountDeleted = false
      }
    },
    onSend () {
      this.clearAllWarningMessages()
    },
    scrollToFaq () {
      document.querySelector('.cso-faq')?.scrollIntoView()
    },
    getServerError (errors: string) {
      this.clearAllWarningMessages()
      this.serverErrors = errors
    },
    clearAllWarningMessages () {
      this.serverErrors = ''
      this.sessionLost = false
      this.accountLogout = false
    }
  },
  created () {
    this.getUrlId()
  }
}
</script>

<style scoped lang="scss">

.main-title {
    font-family: $font-family-bold;
    font-size: 48px;
    margin-top: 18px;
    margin-bottom: 32px;

    @include sm {
      font-size: 28px;
      margin: 20px 6px 24px 6px;
    }
}

.cso-double-login-component {
  padding: 22px 0;

  background-color: $white;
  color: $black;
  position: relative;
  overflow: hidden;
  min-height: 400px;
  font-family: $font-family-regular;

  @include md-1 {
    height: auto;
    padding: 12px 0;
  }

  .custom-message-wrapper {
    background-color: $light-red;
    margin: 0 3em 1em 3em;
    text-align: left;
    position: relative;
    padding: 8px 12px;

    p.title-message {
      font-family: $font-family-bold;
    }

    p {
      margin: 0;
    }

    @include md {
      margin: 0 1rem;
    }
  }

  .grid-column-wrapper {
    position: relative;

    @include sm {
      margin: 0;
    }

    & > h3 {
      position: absolute;
      top: -2em;
      width: 100%;
      text-align: center;
      left: -50%;
      margin: 0;
      z-index: 20;

      @include md {
        display: none;
      }
    }
  }

  header {
    padding: 0.5em 1em;
    position: absolute;
    width: 100%;
    margin: 0 10px;
    z-index: 20;

    h2 {
      text-align: center;

      @include sm {
        text-align: center;
        line-height: 30px;
      }
    }

    a {
      position: absolute;
      top: 0.9em;
      right: 0.9em;
    }
    a.faq {
      top: 1.5em;
      right: initial;
      display: none;

      @include sm {
        display: initial;
      }
    }
  }

  .overlay {
    position: absolute;
    top: -4em;
    left: 10px;
    right: 0;
    bottom: 0;
    z-index: 10;
    background-color: rgba(230, 230, 230, 0.7);

    @include md {
      right: 10px;
    }

    @include sm {
      top: -2em;
    }
  }
}
</style>
